import script from "./TemplateTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateTwo.vue?vue&type=script&setup=true&lang=js"

import "./TemplateTwo.vue?vue&type=style&index=0&id=07dbd460&lang=css"

const __exports__ = script;

export default __exports__